import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { IAccount } from "../../../common/accounts2";
import { NewAccountKrkCitizen } from "../molecules/NewAccountKrkCitizen";
import { NewAccountKrkOrganization } from "../molecules/NewAccountKrkOrganization";
import { $SiteColors } from "../../../common/config/company-atts";

interface INewAccountKrkBlock {
  goTo?: number; //указываем то, куда перейти после завершения или отмены добавления аккаунта(учитывается если redirectTo или redirectToOnCancel отсутствуют)
  redirectTo?: string; //переходим по этому адресу в случае успешного результата
  comid: string; //идентификатор компании, по которому добавляется аккаунт
  hideAnon?: boolean; //этот параметр указывает на то, показывать ли кнопку для анонимного входа(при нажатии на эту кнопку перенаправляем на главную страницу)
  clearDataOnCancel?: boolean;
}

export const NewAccountKrkBlock = ({
  comid,
  redirectTo = "",
  goTo = -1,
  hideAnon = true,
}: INewAccountKrkBlock) => {
  const [citizen, setCitizen] = useState(true); //указывает на то, добавляется ли аккаунт по Физ. лицу
  const [newAccount, setNewAccount] = useState<IAccount | null>(null);
  const [isValid, setIsValid] = React.useState(false);
  const [disableWhileLoading, setDisableWhileLoading] = React.useState(false);

  const his = useHistory();

  const switchFormType = () => {
    setCitizen(!citizen);
  };

  const onAnonClicked = () => {
    window.location.href = window.location.pathname.split("/")[1];
  };

  const onCancelClicked = () => {
    his.goBack();
  };

  return (
    <>
      <div className="addacc__buttons">
        <button
          className={
            citizen ? "addacc__button addacc__button_active" : "addacc__button"
          }
          style={
            citizen
              ? { backgroundColor: $SiteColors.getState().backBtnSubmit }
              : { color: "#00000088" }
          }
          onClick={switchFormType}
          disabled={disableWhileLoading}
        >
          {comid === "34" ? "Житель" : "Физ. лицо/ ИП"}
        </button>
        <button
          className={
            !citizen ? "addacc__button addacc__button_active" : "addacc__button"
          }
          style={
            !citizen
              ? { backgroundColor: $SiteColors.getState().backBtnSubmit }
              : { color: "#00000088" }
          }
          onClick={switchFormType}
          disabled={disableWhileLoading}
        >
          Организация
        </button>
      </div>
      <div>
        {citizen ? (
          <NewAccountKrkCitizen
            setNewAccount={setNewAccount}
            onCancelClicked={onCancelClicked}
            hideAnon={hideAnon}
            onAnonClicked={onAnonClicked}
            isValid={isValid}
            setIsValid={setIsValid}
            comId={comid}
            disableWhileLoading={disableWhileLoading}
            setDisableWhileLoading={setDisableWhileLoading}
            redirectTo={redirectTo}
          />
        ) : (
          <NewAccountKrkOrganization
            comid={comid}
            setNewAccount={setNewAccount}
            onCancelClicked={onCancelClicked}
            hideAnon={hideAnon}
            onAnonClicked={onAnonClicked}
            isValid={isValid}
            setIsValid={setIsValid}
            disableWhileLoading={disableWhileLoading}
            setDisableWhileLoading={setDisableWhileLoading}
            redirectTo={redirectTo}
          />
        )}
      </div>
    </>
  );
};
